import React, { useState, useEffect } from "react";
import {
  //Button,
  Col,
  Dropdown,
  OverlayTrigger,
  Row,
  Spinner,
  Tooltip,
  Alert,
} from "react-bootstrap";

import { Button } from "@shopify/polaris";

import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { getUrl } from "../helpers/url";

import { toast } from "react-toastify";

import {
  fetchStatus,
  fetchEnvironment,
  fetchCompanies,
  setDropdownPreferences,
  setIsEnvPreferencesSaved,
  setShowErrorModal,
  setShowSuccessModal,
} from "../store/slices/preferenceSlice";

import { useCmsHook } from "../helpers/cmsHook";
import { CmsConstructor } from "../helpers/cmsConstructor";
import CmsEditAndSave from "../helpers/CmsEditAndSave";

const EnvironmentSelection = () => {
  const { cmsInstance, setCmsInstance, isEdit } = useCmsHook();

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  // preference states
  const {
    environmentPreference,
    companyPreference,
    isMsbcConnected,
    environment: { loading: environmentLoading },
    environment: {
      environmentDetails: { environment },
    },
    company: {
      loading: companiesLoading,
      companyDetails: { companies },
    },
    tenantId,
  } = useSelector((state) => state.preference);

  const toggleText = ({ dropdownFor }) => {
    if (dropdownFor === "environment") {
      if (!environmentPreference) {
        return "Select environment";
      } else {
        const field = environment.find(
          (fieldItem) => fieldItem.name === environmentPreference
        );
        if (field) {
          return field.name;
        } else {
          return "selected environment deleted";
        }
      }
    }
    if (dropdownFor === "company") {
      if (!companyPreference) {
        return "select company";
      } else {
        const field = companies.find(
          (company) => company.id === companyPreference
        );
        if (field) {
          return field.name;
        } else {
          return "selected company deleted";
        }
      }
    }
  };

  const onSavePreferences = async () => {
    try {
      setIsLoading(true);
      const shop = searchParams.get("shop");
      await axios.post(getUrl("REACT_APP_SAVE_ENV_SELECTION"), {
        environment: environmentPreference,
        tenantId,
        shop,
        companyId: companyPreference,
      });
      dispatch(setIsEnvPreferencesSaved());

      dispatch(
        setShowSuccessModal({
          message:
            cmsInstance.sendData().cmsContent.notifications.envSelection
              .successContent.env.message,
        })
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      toast.error(errorMessage, { className: "react-toast-error" });
      dispatch(setShowErrorModal({ message: errorMessage }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const shop = searchParams.get("shop");
    if ((tenantId, shop)) {
      dispatch(fetchStatus({ shop }));
      dispatch(fetchEnvironment({ tenantId, shop }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const shop = searchParams.get("shop");
    if (tenantId && shop && environmentPreference) {
      dispatch(fetchCompanies({ tenantId, shop, environmentPreference }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentPreference]);

  useEffect(() => {
    if (
      window.location.pathname === "/environment" ||
      window.location.pathname === "/env"
    ) {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="environment-selection-container w-100">
      {window.location.pathname === "/environment" && (
        <div className="mt-4 w-100 d-flex justify-content-center">
          <CmsEditAndSave />
        </div>
      )}
      {!isMsbcConnected && (!tenantId || tenantId === "") && (
        <div className="d-flex flex-row align-items-center justify-content-center pt-4">
          <Alert variant="warning" className="mb-0 alert-message">
            Please connect your Microsoft Business Central account.
          </Alert>
        </div>
      )}
      <Row
        className="d-flex flex-row justify-content-center align-items-center h-100 w-100 px-2"
        style={{
          marginTop: `${
            (window.location.pathname === "/setup" ||
              window.location.pathname === "/environment") &&
            isEdit &&
            "50px"
          }`,
        }}
      >
        <Col sm={10} md={5} lg={3} className="env-card px-0">
          <div>
            <div className="oauth-card-heading-container">
              {cmsInstance &&
                cmsInstance.showRichText("cmsContent.preference.heading")}
            </div>
            {environmentLoading ? (
              <div className="d-flex flex-row justify-content-center align-items-center my-3">
                <Spinner
                  animation="border"
                  variant="secondary"
                  role="status"
                  size="md"
                ></Spinner>
              </div>
            ) : (
              <div className="px-4 my-4">
                {cmsInstance &&
                  cmsInstance.showRichText("cmsContent.preference.description")}
                {environment && (
                  <Col>
                    <span className="rules-sub-heading mb-2">
                      Select Environment
                    </span>
                    <Dropdown>
                      <Dropdown.Toggle className="setup-fields-dropdown">
                        {toggleText({ dropdownFor: "environment" })}
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        renderOnMount={true}
                        popperConfig={{ strategy: "fixed" }}
                        className="setup-fields-dropdown-items-container"
                      >
                        {environment &&
                          environment.length > 0 &&
                          environment.map((env) => (
                            <Dropdown.Item
                              Key={env.type}
                              className="px-3 dropdown-item"
                              onClick={() =>
                                dispatch(
                                  setDropdownPreferences({
                                    dropdownFor: "environment",
                                    selectedOption: env.name,
                                  })
                                )
                              }
                            >
                              {env.name}
                            </Dropdown.Item>
                          ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                )}
                {companiesLoading ? (
                  <div className="d-flex flex-row justify-content-center align-items-center my-3">
                    <Spinner
                      animation="border"
                      variant="secondary"
                      role="status"
                      size="md"
                    ></Spinner>
                  </div>
                ) : (
                  <>
                    {environmentPreference && companies && (
                      <Col className="mt-3">
                        <span className="rules-sub-heading mb-2">
                          Select Company
                        </span>
                        <Dropdown>
                          <Dropdown.Toggle className="setup-fields-dropdown">
                            {toggleText({ dropdownFor: "company" })}
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            renderOnMount={true}
                            popperConfig={{ strategy: "fixed" }}
                            className="setup-fields-dropdown-items-container"
                          >
                            {companies &&
                              companies.length > 0 &&
                              companies.map((company) => (
                                <Dropdown.Item
                                  className="px-3 dropdown-item"
                                  key={company.id}
                                  onClick={() =>
                                    dispatch(
                                      setDropdownPreferences({
                                        dropdownFor: "company",
                                        selectedOption: company.id,
                                      })
                                    )
                                  }
                                >
                                  {company.name}
                                </Dropdown.Item>
                              ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </Col>
                    )}
                  </>
                )}

                <div className="d-flex flex-row justify-content-end mt-3">
                  {!companyPreference || !environmentPreference ? (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip style={{ fontSize: "11px" }}>
                          {showToolTipText(
                            companyPreference,
                            environmentPreference
                          )}
                        </Tooltip>
                      }
                    >
                      <div>
                        <Button
                          className="save-changes-button"
                          style={{ opacity: "0.9", cursor: "not-allowed" }}
                          disabled
                        >
                          Save
                        </Button>
                      </div>
                    </OverlayTrigger>
                  ) : (
                    <Button
                      className="save-changes-button"
                      onClick={() => onSavePreferences()}
                      loading={isLoading}
                      primary
                    >
                      Save
                    </Button>
                  )}
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EnvironmentSelection;

const showToolTipText = (companyPreference, environmentPreference) => {
  if (!environmentPreference) {
    return "Please select the environment";
  }
  if (!companyPreference) {
    return "Please select the company";
  }
};
